/** 捕获 Vue 运行时错误，供 legacy 诊断条展示；SecurityError(insecure) 在 HTTP 预览下忽略 */
export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) return

  nuxtApp.vueApp.config.errorHandler = (err, _instance, info) => {
    const msg = `[${info}] ${err instanceof Error ? err.message : String(err)}`
    if (/securityerror/i.test(msg) && /insecure|operation/i.test(msg)) {
      console.warn('[vue-error ignored]', msg)
      return
    }
    ;(window as Window & { __MOJI_VUE_ERROR__?: string }).__MOJI_VUE_ERROR__ = msg
    console.error('[vue-error]', msg, err)
  }
})
